import { vt } from '../theme';

export interface SparklineProps {
  /** One value per point, oldest first; scaled from 0 to the largest. */
  values: readonly number[];
  width?: number;
  height?: number;
  color?: string;
}

/** A stat card's trend (mockup 01's Throughput card): a soft area under a thin line, no axes. Decorative. */
export function Sparkline({ values, width = 90, height = 22, color = vt.cyan }: SparklineProps) {
  const n = values.length;
  const max = Math.max(0, ...values);
  // A 1 px inset keeps the line's stroke inside the box at its peak and along the floor.
  const x = (i: number) => (n <= 1 ? 0 : (i / (n - 1)) * width);
  const y = (v: number) => height - 1 - (max > 0 ? (v / max) * (height - 2) : 0);
  const line = values.map((v, i) => `${i === 0 ? 'M' : 'L'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden data-sparkline style={{ display: 'block' }}>
      <path d={area} fill={color} fillOpacity={0.18} stroke="none" />
      <path d={line} fill="none" stroke={color} strokeWidth={1.25} strokeLinejoin="round" />
    </svg>
  );
}
